/* eslint-disable */
import { Module } from 'vuex'
import { RouteConfig } from 'vue-router'

import { storage } from '@utils/index'
import { State } from '@plugin/store'
import { routes, testRouter } from '@plugin/router/index'
import { getRoutesAndMenus, getQuickRecordList, saveOrUpdateQuickRecord } from '@api/common/index'
export interface MenuItem {
  id: string;
  parentId: string;
  vueUrl: string;
  icon: string;
  sort: string;
  serialVersionUID: string;
  name: string;
  menuType: string;
  menuLevel: string;
  isShow: string;
  children: MenuItem[];
}

export interface MenusMap {
  [prop: string]: MenuItem;
}

export interface Colomn {
  p: string;
  h?: boolean,
  f?: 'left' | 'right' | null
}

interface ColomnRules {
  [prop: string]: Colomn[]
}
export interface Menu {
  menus: MenuItem[];
  menusMap: MenusMap;
  routesMap: MenusMap;
  recentMenus: Array<string>;
  fixedMenus: Array<string>;
  colomnRules: ColomnRules
}

// export interface Meta {
//   icon: string;
//   title: string;
//   sort: string;
//   menuNo: string
// }

function getMenuMap(menus: MenuItem, menusMap: MenusMap = {}, routesMap: MenusMap = {}) {
  menusMap[menus.id] = menus
  routesMap[menus.vueUrl] = menus
  if (menus.children && menus.children.length) {
    menus.children.forEach(item => {
      getMenuMap(item, menusMap, routesMap)
    })
  }
}

function getRoutes(routes: RouteConfig[], menusMap: MenusMap) {
  return routes
    // .filter(route => {
    //   if (route.name && menusMap[route.name]) return true
    //   const dep = route.meta && route.meta.dep
    //   if (dep && menusMap[dep]) return true
    //   return false
    // })
    // .sort((a, b) => {
    //   const mapA = menusMap[a.name as string]
    //   const sortA = mapA ? mapA.sort : null
    //   const sortB = menusMap[b.name as string] ? menusMap[b.name as string].sort : null
    //   if (sortA && sortB) {
    //     return sortA >= sortB ? 1 : -1
    //   }
    //   return 1
    // })
    .map(route => {
      const menu = menusMap[route.name as string]
      const routeMeta = route.meta || {}
      const newRoute = menu
        ? {
          ...route,
          meta: {
            ...routeMeta,
            icon: menu.icon,
            title: menu.name,
            sort: menu.sort,
            menuNo: menu.id
          }
        }
        : route
      if (route.children && route.children.length) {
        newRoute.children = getRoutes(route.children, menusMap)
      }
      return newRoute
    })
}

const store: Module<Menu, State> = {
  namespaced: true,
  state: {
    menus: [],
    menusMap: {},
    routesMap: {},
    recentMenus: [],
    fixedMenus: [],
    colomnRules: storage.get('colomn-rules') as ColomnRules || {}
  },
  mutations: {
    SET_MENUS(state, menus) {
      state.menus = menus
    },
    SET_MENUSMAP(state, map) {
      state.menusMap = map
    },
    SET_ROUTESMAP(state, map) {
      state.routesMap = map
    },
    SET_RECORD(state, data = {}) {
      const { recentMenus = [], fixedMenus = [] } = data
      state.recentMenus = recentMenus
      state.fixedMenus = fixedMenus
    },
    SET_COLOMNRULES(state, colomnRules) {
      state.colomnRules = colomnRules
    }
  },
  actions: {
    async getRoutesByMenus({ state, commit }) {
      const currentRoute = testRouter.resolve(location.pathname).route
      const matchedName = (currentRoute as any).matched[0] && (currentRoute as any).matched[0].name as string
      const menus = await getRoutesAndMenus<MenuItem>(matchedName)
      if (!menus) return [];
      (menus as any).matchedName = matchedName
      commit('SET_MENUS', Object.freeze(menus))
      const menusMap: MenusMap = {}
      const routesMap: MenusMap = {}
      getMenuMap(menus, menusMap, routesMap)
      commit('SET_MENUSMAP', Object.freeze(menusMap))
      commit('SET_ROUTESMAP', Object.freeze(routesMap))
      const newRoutes = routes.map(item => {
        return {
          ...item,
          children: getRoutes(item.children || [], routesMap)
        }
      })
      return newRoutes
    },

    async getQuickRecord({ commit }) {
      const strdata = await getQuickRecordList()
      const data = strdata ? JSON.parse(strdata) : {}
      commit('SET_RECORD', data)
    },

    updateRecent({ commit, state, dispatch }, menu) {
      const recentMenus = [...state.recentMenus]
      if (recentMenus.includes(menu.id)) {
        recentMenus.splice(recentMenus.indexOf(menu.id), 1)
      }
      recentMenus.unshift(menu.id)
      if (recentMenus.length > 4) {
        recentMenus.pop()
      }
      commit('SET_RECORD', { recentMenus, fixedMenus: state.fixedMenus })
      dispatch('saveFixedMenu')
    },

    fixedMenu({ commit, state, dispatch }, menu) {
      const fixedMenus = new Set(state.fixedMenus)
      fixedMenus.add(`${menu.id}`).add(`${menu.parentId}`)
      commit('SET_RECORD', { recentMenus: state.recentMenus, fixedMenus: [...fixedMenus] })
      dispatch('saveFixedMenu')
    },

    fixedMenus({ commit, state, dispatch }, menus: any[]) {
      const fixedMenus = new Set(state.fixedMenus)
      menus.forEach(menu => {
        fixedMenus.add(`${menu.id}`).add(`${menu.parentId}`)
      })
      commit('SET_RECORD', { recentMenus: state.recentMenus, fixedMenus: [...fixedMenus] })
      dispatch('saveFixedMenu')
    },

    unFixedMenu({ commit, state, dispatch }, menu) {
      const fixedMenus = new Set(state.fixedMenus)
      const menuId = `${menu.id}`
      fixedMenus.delete(menuId)
      const siblingMenus = state.menusMap[menu.parentId] ? state.menusMap[menu.parentId].children || [] : []
      const fixedSibling = siblingMenus.filter(item => fixedMenus.has(`${item.id}`))
      if (!fixedSibling.length) {
        fixedMenus.delete(`${menu.parentId}`)
      }
      commit('SET_RECORD', { recentMenus: state.recentMenus, fixedMenus: [...fixedMenus] })
      dispatch('saveFixedMenu')
    },

    unFixedMenus({ commit, state, dispatch }, menu) {
      const fixedMenus = new Set(state.fixedMenus)
      const menuId = `${menu.id}`
      fixedMenus.delete(menuId)
      const children = menu.children || []
      children.forEach((item: any) => {
        fixedMenus.delete(`${item.id}`)
      })
      commit('SET_RECORD', { recentMenus: state.recentMenus, fixedMenus: [...fixedMenus] })
      dispatch('saveFixedMenu')
    },

    async saveFixedMenu({ state }) {
      await saveOrUpdateQuickRecord(JSON.stringify({
        recentMenus: state.recentMenus,
        fixedMenus: state.fixedMenus
      }))
    },
    // 修改列表页面表单的规则
    changeColomnRules({ commit, state }, { name, rule }) {
      const colomnRules = {
        ...state.colomnRules,
        [name]: rule
      }
      commit('SET_COLOMNRULES', colomnRules)
      if (process.env.NODE_ENV === 'production') {
        storage.set('colomn-rules', JSON.stringify(colomnRules))
      }
    }
  }
}
export default store
